varying vec2 vUv; 
varying vec3 vPos; 
varying vec3 vNormal; 
#define PI 3.1415926538
uniform float u_time;
uniform float u_amplitude;
uniform sampler2D u_noiseTexture;

void main(){

    vec3 newPos = position; 
    // float angle = atan(newPos.z, newPos.x);
    // newPos += cos(angle);
float angle = atan(newPos.x, newPos.z);
angle += 0.5 * PI;

    vec2 newUv = uv;
    float speed = 0.6;
    newUv.y -= u_time*speed;
    newUv.x -= cos(newUv.y*1.5);
    float noise = 1.-texture2D(u_noiseTexture, newUv).r;

   
    newPos += normal * noise*0.05;
    
    // 
    vec4 modelPosition = modelMatrix * vec4(newPos, 1.0);



    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // aditionnal calculations
    vUv = uv;
    vPos = position;
    vNormal = (modelMatrix * vec4(normal, 0.0)).xyz;
    // vNormal = normal;

}